// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._container ._entry-btn{$w:40px;$h:40px;$d:flex;$b:#000;opacity:.3;$bra:10px;$po:relative;$z:1000;$tr:opacity .3s;$c:#fff;$fs:25px;align-items:center;justify-content:center}._container ._entry-btn._active,._container ._entry-btn:active{opacity:.8}", ""]);
// Exports
module.exports = exports;
